module.exports = __webpack_public_path__ + "static/photo3-5ccfd26bc4d399e2b0003a89cc39d446.png";